import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_CHIDELETE } from "../actions/DanhSachChiDelete/actionTypes";
import {
  getListChiDeleteSuccess,
  getListChiDeleteFailure,
} from "../actions/DanhSachChiDelete";
import DanhSachChiDeleteApi from "../service/danhSachChiDeleteApi";

function* getListChiDelete(action) {
  try {
    const response = yield call(
      DanhSachChiDeleteApi.GetDanhSachChiDelete,
      action.dataSearch
    );
    if (response.ok) {
      yield put(getListChiDeleteSuccess(response.data));
    } else {
      yield put(getListChiDeleteFailure());
    }
  } catch (error) {
    yield put(getListChiDeleteFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_CHIDELETE, getListChiDelete);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
